<span class="fl-fixed fl fl-ai-c fl-jc-c">
	<ng-content select="[icon]"></ng-content>
</span>

<span class="fl-adaptable fl fl-ai-c fl-jc-fs ellipsis border-box" [ngClass]="textClass">
	<ng-content></ng-content>
</span>
